<template>
  <div class="title">
    <label class="text">𝖂𝖊 𝖆𝖗𝖊 𝕬𝖑𝖑 𝕲𝖔𝖎𝖓𝖌 𝕿𝖔 𝕯𝖎𝖊 𝖎𝖓 𝕭𝖆𝖙𝖙𝖑𝖊</label>
    <label class="text">𝕾𝖔𝖔𝖓 𝖜𝖊 𝖜𝖎𝖑𝖑 𝖗𝖆𝖎𝖉 𝖙𝖔𝖌𝖊𝖙𝖍𝖊𝖗, 𝖙𝖍𝖊 𝖒𝖔𝖗𝖊 𝖔𝖋 𝖚𝖘 𝖙𝖔𝖌𝖊𝖙𝖍𝖊𝖗 𝖙𝖍𝖊 𝖒𝖔𝖗𝖊 𝖉𝖆𝖒𝖆𝖌𝖊 𝖜𝖊 𝖈𝖆𝖓 𝖉𝖔.</label>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

body {
  padding: 0px;
  margin: 0px;
  background-color: black;
}

.title {
  position: relative;
  display: flex;
  width: 100%;
  justify-content:center;
  align-items: center;
  margin-top: 100px;
  font-size: 20px;
  flex-direction: column;
  padding-bottom: 400px;
}

.text {
  position: relative;
  display: flex;
  width: 75%;
  text-align: center;
  flex-direction: column;
  margin-bottom: 40px;
}

.dono {
  position: relative;
  display: flex;
  font-size: 10px;
  width: 60%;
  flex-direction: column;
}

.dono2 {
  position: relative;
  display: flex;
  font-size: 10px;
  width: 50%;
  flex-direction: column;
  min-width: 470px;
  margin-top: 20px;
}

</style>
